import React, { Component } from 'react'
import './AnimNum_style.css'

class AnimNumCP extends Component {
  constructor(props) {
    super(props)
    this.state = {
      n:props.n,
      diff: 0,
    }
  }

  render() {
    let bumpKey = `bump_${this.state.n}`
    let diffKey = `dif_${this.state.n}`
    let diffTxt = ''
    let diffColorClass = 'anDifNone'
    if (this.state.diff !== 0 && !isNaN(this.state.diff)) {
      let prefix = '+'
      diffColorClass = 'anDiffPos'
      if (this.state.diff < 0) {
        prefix = ''
        diffColorClass = 'anDiffNeg'
      }
      diffTxt = `${prefix}${this.state.diff}`
    }
    return (
      <div className='anMain'>
        <div className='anNum'>{this.state.n}</div>
        <div key={bumpKey} className='anBump'>{this.state.n}</div>
        <div key={diffKey} className={`anDiff ${diffColorClass}`}>{diffTxt}</div>
      </div>
    )
  }

  componentDidUpdate() {
    if (undefined !== this.props?.n) this.update(this.props.n)
  }

  update(n) {
    if (undefined !== this.state?.n && this.state.n !== n) {
      this.setState({
        n: n,
        diff: (n - this.state.n),
      })
    }
  }
  
}

export default AnimNumCP
